import React from "react";
import LandingPageLayout from "../../shared/Layouts/LandingPageLayout";
import { BACKGROUND_BEHIND } from "../../assets";
import { ChiefRegistrar as Registrars } from "../../constants";

function ChiefRegistrar() {
  return (
    <LandingPageLayout
      title={<>Chief Registrar and DCRs</>}
      currentLink="Structure of the court"
    >
      <div className="flex items-center justify-center flex-col p-6 sm:p-8 lg:p-10">
        <div className="w-full sm:w-[60%] lg:w-[30%] flex flex-col relative items-center justify-center gap-y-3">
          <div className="bg-[#F5F5F5] p-3 sm:p-4 lg:p-5 rounded-lg w-full flex items-center justify-center">
            <img
              src={Registrars[0].image}
              className="w-full min-h-[280px] sm:min-h-[320px] lg:min-h-[360px] object-cover h-full z-30 rounded-md"
              alt={Registrars[0].name}
            />
          </div>
          <img
            src={BACKGROUND_BEHIND}
            className="absolute w-full object-cover h-[200px] sm:h-[240px] lg:h-[271px] z-10 bottom-[2rem] sm:bottom-[2.5rem] lg:bottom-20"
            alt=""
          />

          <div className="flex flex-col justify-center gap-y-2 sm:gap-y-3 items-center mt-3 px-4 text-center">
            <span className="text-globalGreen text-sm sm:text-[16px] font-semibold">
              {Registrars[0].name}
            </span>
            <span className="text-xs sm:text-sm font-medium text-gray-regular text-center leading-relaxed">
              {Registrars[0].role}
            </span>
          </div>
        </div>
        <div className="w-full flex flex-col sm:flex-row justify-center gap-6 sm:gap-8 lg:gap-10 px-4 sm:px-8 lg:px-40 mt-8 sm:mt-10">
          {Registrars.slice(1).map((item, index) => (
            <div
              key={index}
              className="w-full sm:w-[45%] lg:w-[35%] flex flex-col relative items-center justify-center gap-y-3"
            >
              <div className="bg-[#F5F5F5] p-3 sm:p-4 lg:p-5 rounded-lg w-full flex items-center justify-center">
                <img
                  src={item.image}
                  className="w-full min-h-[280px] sm:min-h-[320px] lg:min-h-[360px] object-cover h-full z-30 rounded-md"
                  alt={item.name}
                />
              </div>
              <img
                src={BACKGROUND_BEHIND}
                className="absolute w-full object-cover h-[200px] sm:h-[240px] lg:h-[271px] z-10 bottom-[2rem] sm:bottom-[2.5rem] lg:bottom-20"
                alt=""
              />

              <div className="flex flex-col justify-center gap-y-2 sm:gap-y-3 items-center mt-3 px-4 text-center">
                <span className="text-globalGreen text-sm sm:text-[16px] font-semibold">
                  {item.name}
                </span>
                <span className="text-xs sm:text-sm font-medium text-gray-regular text-center leading-relaxed">
                  {item.role}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </LandingPageLayout>
  );
}

export default ChiefRegistrar;
